import React, { Component } from "react";
import { Spinner } from "react-bootstrap";

// font awesome
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export class DownloadExcelReportAgenda extends Component {
  delayUpdate = null;

  onDownload = e => {
    const { onClearDownload, resetPlaceholder } = this.props;
    onClearDownload && onClearDownload();
    resetPlaceholder && resetPlaceholder();
  };

  render() {
    const {
      props: {
        excelStyle,
        isLoading,
        downloadLink,
        onStartDownloading,
        iconClass,
        iconClassName = iconClass
          ? "download-icons-excel-state"
          : "download-icons-excel",
        border,
        onDownloadLinkClick,
        isDraft,
        isMis
      },
      onDownload
    } = this;
    console.log("downloadLink", downloadLink);
    console.log("isLoading", isLoading);
    let excelClassName;
    // if (isDraft) {
    //   excelClassName = `download-excel-component-draft1`;
    // } else if (isMis) {
    //   excelClassName = `download-excel-component-mis`;
    // } else {
    //   excelClassName = ;
    // }
    return (
      // <div className="download-excel-component">
      <span
        className={`download-excel-component-draft2 ${
          excelStyle ? "excel-component" : ""
        } ${border ? "download-excel-radius" : ""}`}
      >
        {isLoading ? (
          <span className="download-icon downloading">
            <span className={iconClassName} />
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </span>
        ) : downloadLink ? (
          <span className="download-icon agenda-download-ppt-icon">
            <a
              className="download-img"
              download={"Abcde.xls"}
              href={downloadLink}
              target={iconClassName === "pdf-icon" ? "_blank" : ""}
              onClick={onDownload}
            >
              <FontAwesomeIcon icon={faDownload} size="2x" />
            </a>
          </span>
        ) : (
          <span
            onClick={onStartDownloading}
            className="download-mis-file download-icon "
          >
            <span className={iconClassName} />
          </span>
        )}
      </span>

      // </div>
    );
  }
}
